// Utility to extract the first valid PMO reference from a string.
// Returns the first match like 'PMO-1234', or null if none found.
// Exclude PMO-123 as an example/test value
export function extractFirstValidPMO(text: string): string | null {
  if (!text) return null;
  // If the word 'example' appears anywhere, skip detection
  if (/example/i.test(text)) return null;
  // Only match PMO- (case-insensitive), dash, 1 or more digits (e.g., PMO-1234, pmo-1234)
  const regex = /\b([Pp][Mm][Oo]-\d{1,})\b/g;
  let match;
  while ((match = regex.exec(text)) !== null) {
    // Exclude PMO-123 and PMO-12345 as example/test values
    if (
      match[1].toUpperCase() !== 'PMO-123' &&
      match[1].toUpperCase() !== 'PMO-12345'
    ) {
      return match[1];
    }
  }
  return null;
}
